import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { FilteredTemplateList } from "../CreateNewWorkflow/components/TemplateList/FilteredTemplateList";
import { CreateWorkflowProvider } from "../CreateNewWorkflow/provider/WorkflowFormDataProvider";

interface EmptyWorkflowsProps {
  category?: string;
  onClose?: () => void;
  shouldAutoAdjust?: boolean;
}

export const EmptyWorkflows = ({
  category,
  onClose,
  shouldAutoAdjust,
}: EmptyWorkflowsProps) => (
  <CreateWorkflowProvider category={category}>
    <div className="w-fit px-6">
      <Typography.TitleSm weight="bold">
        {t("settings.workflows.workflows")}
      </Typography.TitleSm>
      <FilteredTemplateList
        shouldIncludeCreateButton
        onClose={onClose}
        shouldAutoAdjust={shouldAutoAdjust}
      />
    </div>
  </CreateWorkflowProvider>
);
